export const RESET_CURRENT_PARTNER = 'RESET_CURRENT_PARTNER';

export function resetPartner() {
  return {
    type: RESET_CURRENT_PARTNER
  };
}
